import { SettingsItem } from "./SettingsItem";
import { getPublicPath } from "../helpers";

export const Checkout = ({ className = "" }) => {
  const items = ["1. Stand: right", "2. Stand: left", "3. Float: right", "4. Float: left", "5. Front", "6. Side"].map((item) => (
    <li
      key={item}
      className="p-0 py-4 border border-l-0 border-r-0 border-t-0 border-gray-100 flex justify-between"
    >
      <span>{item}</span>
      <span>x1</span>
    </li>
  ));
  return (
    <SettingsItem title="Checkout" className={className}>
      <p className="pb-8">Each file is 5120×2880 px (PNG)</p>
      <p className="pb-2">
        <p className="text-lg font-semibold	">Files:</p>
      </p>
      <ul className="list-none">{items}</ul>
      <p className="py-10 text-3xl">$9.99</p>
      <button className="mb-4">
        <img
          className="mx-auto"
          alt="Apple Pay"
          src={getPublicPath("images/Apple-Pay.svg")}
        />
      </button>
      <button className="transition duration-100 ease-in-out secondary hover:bg-gray-200">Credit Card</button>
    </SettingsItem>
  );
};
